import debounce from "lodash.debounce";
import { CLASSES } from '../_consts';

export default function categoriesView() {
  const links = Array.prototype.slice.call(document.querySelectorAll('.js-products-list-button'));
  const contentBlock = document.querySelector('.js-cards-list');
  const { isExpanded, isActive } = CLASSES;


  if (links.length) {
    links.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        const target = e.currentTarget;
        const toExpand = (target.dataset.expanded === 'true');

        for (let i = 0; i < links.length; i++) {
          links[i].classList.remove(isActive);
        }
        target.classList.add(isActive);

        if (toExpand) {
          contentBlock.classList.add(isExpanded);
        } else {
          contentBlock.classList.remove(isExpanded);
        }

        window.instances.forEach((ins) => {
          ins.update();
        });
      });
    });
    window.addEventListener('resize', debounce(() => {
      if (window.matchMedia('(max-width: 768px)').matches) {
        contentBlock.classList.remove(isExpanded);
      }
    }, 300))
  }
}
